/**
 * Professions Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";
import AppConfig from "../../../constants/AppConfig";

// States
const state = {
    followUpCategories: [],
    followUpCategory: {},
};

// Getters
const getters = {
    followUpCategories: state => {
        return state.followUpCategories
    },

    followUpCategory: state => {
        return state.followUpCategory
    }
};

// Actions
const actions = {
    getFollowUpCategories(context, payload) {
        function successCallback(response) {
            context.commit('getFollowUpCategoriesHandler', { followUpCategories: response.data.categories });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.FollowedCategory.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getFollowUpCategory(context, payload) {
        function successCallback(response) {
            context.commit('getFollowUpCategoryHandler', { followUpCategory: response.data.categorie });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.FollowedCategory.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateFollowUpCategories(context, followUpCategory) {
        context.commit('getFollowUpCategoryHandler', { followUpCategory: followUpCategory });
    },
};

// Mutations
const mutations = {
    getFollowUpCategoriesHandler(state, { followUpCategories }) {
        // Update followUpCategories state
        state.followUpCategories = followUpCategories;
    },

    getFollowUpCategoryHandler(state, { followUpCategory }) {
        // Update followUpCategory state
        state.followUpCategory = followUpCategory;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
